import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

/**
 * Componente Column para el sistema de grid
 * Ahora utiliza clases CSS definidas en _grid-system.scss en lugar de estilos inline
 * Mantiene la compatibilidad con los componentes existentes
 * 
 * @param {Object} props - Propiedades del componente
 * @returns {React.Element} - Elemento React
 */
const Column = ({
  children,
  className,
  span,
  size,
  sm,
  md,
  lg,
  xl,
  as: Component = 'div',
  ...rest
}) => {
  // Usar span como valor principal, pero si no está definido, usar size como fallback
  const columnSpan = span !== undefined ? span : size;
  
  // Construir nombre de clase utilizando clases de columnas responsivas
  const colClass = cx(
    // Clase base para todas las columnas
    'grid-column',
    
    // Aplicar clases de columna para diferentes puntos de interrupción
    columnSpan && `col-xs-${columnSpan}`,
    sm && `col-sm-${sm}`,
    md && `col-md-${md}`,
    lg && `col-lg-${lg}`,
    xl && `col-xl-${xl}`,
    
    // Clases personalizadas adicionales
    className
  );

  return (
    <Component className={colClass} {...rest}>
      {children}
    </Component>
  );
};

Column.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  span: PropTypes.number,
  size: PropTypes.number, // Alias de span para compatibilidad
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
  xl: PropTypes.number,
  as: PropTypes.elementType,
};

export default Column;
